import { render, staticRenderFns } from "./SmartMedical.vue?vue&type=template&id=ba4813f8&"
import script from "./SmartMedical.vue?vue&type=script&lang=js&"
export * from "./SmartMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports